import {HttpModelConverter} from '../../../../../../core/converter/httpModel.converter';
import {FormDefinitionFormSummaryModel} from '../formDefinitionFormSummary.model';
import {LovValueSummaryConverter} from '../../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter';
import {AccountSummaryConverter} from '../../../../../../account/common/api.converter/AccountSummary.converter';
import {Injectable} from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class FormDefinitionFormSummaryConverter extends HttpModelConverter<FormDefinitionFormSummaryModel> {

    protected createInstance(): FormDefinitionFormSummaryModel {
        return new FormDefinitionFormSummaryModel();
    }

    protected enrichObject(result: FormDefinitionFormSummaryModel, src: FormDefinitionFormSummaryModel) {
        result.context = new LovValueSummaryConverter().convert(src.context);
        result.account = new AccountSummaryConverter().convert(src.account);
    }
}
